module.exports = __webpack_public_path__ + "img/gricon2.e935f016.png";